import SVG, { CustomSVGProps } from '@/src/components/common/SVG/SVG'

export default function SVGAnnouncement(props: CustomSVGProps) {
  return (
    <SVG width="19" height="15" viewBox="0 0 19 15" fill="none" {...props}>
      <path
        d="M14.666 6.41663C14.666 7.03079 14.666 7.63579 14.666 8.24996C15.766 8.24996 17.196 8.24996 18.3327 8.24996C18.3327 7.63579 18.3327 7.03079 18.3327 6.41663C17.196 6.41663 15.766 6.41663 14.666 6.41663Z"
        fill="currentColor"
      />
      <path
        d="M12.832 12.4758C13.712 13.1267 14.8579 13.9883 15.7654 14.6667C16.132 14.1808 16.4987 13.6858 16.8654 13.2C15.9579 12.5217 14.812 11.66 13.932 11C13.5654 11.495 13.1987 11.99 12.832 12.4758Z"
        fill="currentColor"
      />
      <path
        d="M16.8654 1.46667C16.4987 0.980833 16.132 0.485833 15.7654 0C14.8579 0.678333 13.712 1.54 12.832 2.2C13.1987 2.68583 13.5654 3.18083 13.932 3.66667C14.812 3.00667 15.9579 2.15417 16.8654 1.46667Z"
        fill="currentColor"
      />
      <path
        d="M1.83333 4.58331C0.825 4.58331 0 5.40831 0 6.41665V8.24998C0 9.25831 0.825 10.0833 1.83333 10.0833H2.75V13.75H4.58333V10.0833H5.5L10.0833 12.8333V1.83331L5.5 4.58331H1.83333ZM6.44417 6.15081L8.25 5.06915V9.59748L6.44417 8.51581L6.00417 8.24998H5.5H1.83333V6.41665H5.5H6.00417L6.44417 6.15081Z"
        fill="currentColor"
      />
      <path
        d="M12.375 7.33328C12.375 6.11412 11.8433 5.01412 11 4.26245V10.395C11.8433 9.65245 12.375 8.55245 12.375 7.33328Z"
        fill="currentColor"
      />
    </SVG>
  )
}
